import React from 'react'
import styles from "./HomeIntroHero.module.css";
import { motion } from "framer-motion";
import { useMotion } from '@logic/Functions/Hooks/useMotion';
import CallToActionForm from '@components/Forms/CallToActionForm';

const CallToAction: React.FC = () => {

  const { slideFade, containerStagger } = useMotion();

  
  return (
    <section
    className={styles.HSSection}
    aria-labelledby="home-services-title"
    data-testid="home-services-section"
  >
    <motion.header
      className={styles.HSHeader}
      variants={containerStagger(0.12)}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.2 }}
    >
      <motion.h2
        id="home-services-title"
        className={styles.HSServicesTitle}
        variants={slideFade("left", 0)}
      >
        Ready to automate your space?
      </motion.h2>

      <motion.p
        className={styles.HSSubtitle}
        variants={slideFade("right", 0.06)}
      >
        Tell us what you need. We will help design the system around the rooms, people, and routines that matter most.
      </motion.p>
    </motion.header>

    <motion.div
      variants={containerStagger(0.15)}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.2 }}
    >
        <motion.article
          className={styles.HSCard}
          variants={slideFade("up", 0.03)}
        >
            <CallToActionForm />
        </motion.article>
    </motion.div>
  </section>
  )
}

export default CallToAction;
